/**
 * Admin Configuration
 * IMPORTANT: Keep this URL secret!
 */

// Secret admin URL - change this to something unique
export const ADMIN_BASE_URL = '/cd-secure-7e511cdb';

// System Roles
export const SYSTEM_ROLES = {
  SUPER_ADMIN: 'super_admin',
  SUPPORT: 'support',
  BILLING_ADMIN: 'billing_admin'
};

// Role permissions
export const ROLE_PERMISSIONS = {
  super_admin: {
    canManageTenants: true,
    canManageUsers: true,
    canManageBilling: true,
    canManageSystemUsers: true,
    canViewAnalytics: true,
    canCompUsers: true,
    canAccessSupport: true,
    canManageSettings: true
  },
  support: {
    canManageTenants: false,
    canManageUsers: false,
    canManageBilling: false,
    canManageSystemUsers: false,
    canViewAnalytics: true,
    canCompUsers: false,
    canAccessSupport: true,
    canManageSettings: false
  },
  billing_admin: {
    canManageTenants: false,
    canManageUsers: false,
    canManageBilling: true,
    canManageSystemUsers: false,
    canViewAnalytics: true,
    canCompUsers: true,
    canAccessSupport: false,
    canManageSettings: false
  }
};

// Check if user has permission
export const hasPermission = (role, permission) => {
  const perms = ROLE_PERMISSIONS[role];
  return perms ? perms[permission] : false;
};
